<div class="">
   <div class="contentBox">
      <ul class="brand-details-list team-list font-16">
         <li>
            <div class="person-pic">
               <div class="icon pic margin-b-20 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <img src="assets/images/nitin.jpg" alt="">
               </div>
               <div class="margin-b-30 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="100ms">
                  <div class="font-17 proximaNovaSb">Nitin Seth</div>
                  <div class="font-14 light-color proximaNovaSb">Managing Partner, Co-founder & CEO, Incedo</div>
               </div>
               <div class="social-media flex wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="100ms">
                  <a href="https://www.linkedin.com/in/nitinseth/" target="_blank" class="icon">
                     <img src="assets/images/linkedin.png" alt="">
                  </a>
                  <a href="https://twitter.com/seth_nitin?lang=en" target="_blank" class="icon margin-l-20">
                     <img src="assets/images/twitter.png" alt="">
                  </a>
               </div>
            </div>
            <div class="person-details line-25">
               <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
              Nitin Seth is an accomplished industry leader with a unique combination of experiences – of an entrepreneur, a management consultant and a
              senior executive.
               </div>
               <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
              As the Chief Executive Officer at Incedo, Nitin is responsible for definition and execution of Incedo’s strategy, creating and implementing on
              the company’s vision and mission and shaping a unique and effective organization culture. He is currently leading an organization wide
              transformation to realize the company’s goal of becoming a world-class technology solutions firm that delivers exceptional client value,
              has distinctive capabilities, and is an aspirational workplace for the best of minds.
               </div>
               <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
              Nitin has led organizations and achieved significant impact by raising the trajectory of their businesses, driving from strategy to execution,
              championing innovation, building hi-performance teams, coaching and inspiring leaders and most importantly, leading with passion and integrity.
               </div>
               <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
              Prior to Incedo, Nitin was the Chief Operating Officer of Flipkart, where he was responsible for customer and supply chain operations,
              strategy to execution capabilities and corporate functions for the company. He has also headed Fidelity International as the M.D and Country Head
               for India. Prior to Fidelity, Nitin was the Director of McKinsey’s Global Knowledge Centre in India (McKC).
                Nitin is a well-known and respected leader of the IT, BPO sector and Analytics industry. He has been elected twice to the NASSCOM Executive
                Council and was also the Chairperson of the Nasscom Regional Council (NRC) in Haryana.
              He is an avid speaker in the areas of entrepreneurship, business transformation and technology.
               </div>
               <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
              He holds an MBA (Majors in Finance and Operations) from the Indian Institute of Management,
              Lucknow and a degree in engineering (B.Tech) from the Indian Institute of Technology, Delhi.
               </div>
               <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
              He is the author of two best-selling books: Winning in the Digital Age: Seven Building Blocks of a Successful Digital Transformation
              and Managing the Data Paradox: Key to Winning in the AI Age. He has twice served on the NASSCOM Executive Council and was Chairperson
               of the NASSCOM Regional Council (NRC) in Haryana, India.
               </div>




               <!-- <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
                  <div class="proximaNovaSb margin-b-10">Professional Experience:</div>
                  <ul class="points">
                     <li>Incedo, Inc: CEO (2017 - current)</li>
                     <li>Flipkart: Chief Operating Officer (2016-2017)</li>
                     <li>Fidelity: Head of Global Strategy and India Country Head (2010-2016)</li>
                     <li>NASSCOM: Chairperson, Haryana (2011 - 2016)</li>
                     <li>McKinsey Knowledge Center: Director (2002-2010)</li>
                     <li>ActiveKarma: Co-Founder (2000-2002)</li>
                     <li>McKinsey: Consultant (1996-2000)</li>
                  </ul>
               </div> -->
               <!-- <div class=" wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
                  <a routerLink="/capitals/platform-services" fragment="nitin" class="highlight-color sapientsansmedium font-14">More about Nitin Seth</a>
               </div> -->
            </div>
         </li>
         <li>
            <div class="person-pic">
               <div class="icon pic margin-b-20 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="50ms">
                  <img src="assets/images/nateSinger.jpg" alt="">
               </div>
               <div class="margin-b-30 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="100ms">
                  <div class="font-17 proximaNovaSb">Nate Singer</div>
                  <div class="font-14 light-color proximaNovaSb">Advisor</div>
               </div>
               <div class="social-media flex wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
                  <!--                  <a href="https://www.linkedin.com/in/nitinseth/" target="_blank" class="icon">-->
                  <!--                     <img src="assets/images/twitter.png" alt="">-->
                  <!--                  </a>-->
                  <a href="https://www.linkedin.com/in/nate-singer-0078952/" target="_blank" class="icon">
                     <img src="assets/images/linkedin.png" alt="">
                  </a>
               </div>
            </div>
            <div class="person-details line-25">
               <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="50ms">
                  As leader of the Mission Capital team, Nate Singer is responsible for investing Mission Holdings’
                  liquid capital, via a portfolio of direct investments and external managers.
               </div>
               <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
                  Nate has 15+ years investment experience and has worked at top-tier institutions including Bain &
                  Company and Noonday Asset Management, an affiliate of Farallon Capital Management. He is also an
                  entrepreneur and founder of Angel Island Partners LLC., a U.S. focused equities management firm.
               </div>
               <div class=" wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
                  Nate graduated from the University of California, Berkeley, with a BA in Mathematics as Phi Beta Kappa
                  and Valedictorian of the mathematics department before going on to earn his MBA at the Harvard
                  Business School where he served as Co-President of the HBS Investment Club.
               </div>
            </div>
         </li>
      </ul>
   </div>
</div>
